import {
  ExtendedRawUserProfile,
  SocialProfileDTO
} from 'hooks/useIdentifyAnalytics/types';
import { PianoUser } from 'types/piano';
import { RIVT_ROLES } from 'lib/constants';

import { HeaderUserProfile, FooterUserProfile } from './types';

/**
 * Profile switching is not fully implemented yet,
 * so we don't want to show other user's profiles for now, just the main one
 */
export function headerProfileFactory(
  RIVTProfile: ExtendedRawUserProfile
): HeaderUserProfile {
  const socialProfiles = RIVTProfile.social_profiles;

  const userProfileDTO = socialProfiles.find(
    (profile) => profile.type === 'user'
  );

  const mapToUserProfile = (profile: SocialProfileDTO): HeaderUserProfile => ({
    uuid: profile.uuid,
    username: profile.username,
    avatarURL: profile.avatar_url,
    displayName: profile.display_name,
    type: 'user'
  });

  const userProfile = mapToUserProfile(userProfileDTO);

  return userProfile;
}

export function footerProfileFactory(
  RIVTProfile: ExtendedRawUserProfile,
  pianoUser: PianoUser
): FooterUserProfile {
  const socialProfiles = RIVTProfile.social_profiles;

  const userProfileDTO = socialProfiles.find(
    (profile) => profile.type === 'user'
  );

  const mapToUserProfile = (profile: SocialProfileDTO): FooterUserProfile => {
    const isOutsidePlus = pianoUser.roles.includes(
      RIVT_ROLES.ActivePassFull || RIVT_ROLES.Oplus
    );

    return {
      uuid: profile.uuid,
      username: profile.username,
      avatarURL: profile.avatar_url,
      displayName: profile.display_name,
      isEmailVerified: pianoUser.email_verified,
      isOutsidePlus
    };
  };

  const userProfile = mapToUserProfile(userProfileDTO);

  return userProfile;
}
